<template>
    <div>
        <b-row>
            <b-col v-if="token != null">

                <b-row>
                    <b-col class=" fadeInDown">
                        <p></p>

                        <b-row align-h="center" align="center">
                            <b-col cols="12" md="6" lg="3">
                                <h1>Vales</h1>


                                <!--{{ "valor del token" + this.token }}-->
                            </b-col>
                        </b-row>

                        <b-row align-h="center" align="center">

                            <!--DEPARTAMENTOS-->
                            <b-col cols="6" lg="3" class="card-option mb-4 ml-4 mr-4 " @click="seleccionaDepartamento"
                                style="cursor: pointer;">

                                <div v-if="banderaDepartamento != 1">
                                    <b-icon icon="building" font-scale="6" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Departamento</h5>
                                </div>

                                <div v-if="banderaDepartamento == 1">
                                    <b-icon icon="building" font-scale="2" class="mb-1 mt-4"></b-icon>
                                    <h6 class="mb-5">Departamento</h6>
                                    {{ selectedDepartamentos.descDepartamento }}
                                </div>
                            </b-col>

                            <!--UNIDADES-->
                            <b-col cols="6" lg="3" class="card-option mb-4 ml-4 mr-4 " @click="seleccionaUnidad"
                                style="cursor: pointer;">

                                <div v-if="banderaUnidad != 1">
                                    <b-icon icon="truck" font-scale="6" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Unidad</h5>
                                </div>


                                <div v-if="banderaUnidad == 1">
                                    <b-icon icon="truck" font-scale="2" class="mb-1 mt-4"></b-icon>
                                    <h6 class="mb-5">Unidad</h6>
                                    {{ selectedUnidades.descUnidad }}
                                </div>

                            </b-col>

                            <!--DATOS DE CARGA-->
                            <b-col cols="6" lg="3" class="card-option mb-4 ml-4 mr-4 " @click="seleccionaCarga"
                                style="cursor: pointer;">

                                <div v-if="banderaCarga != 1">
                                    <b-icon icon="clipboard-check" font-scale="6" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Datos Carga</h5>
                                </div>

                                <div v-if="banderaCarga == 1">
                                    <b-icon icon="clipboard-check" font-scale="2" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Datos Carga</h5>
                                    {{ selectedCarga }}
                                    {{ nLitros + " litros" }}
                                    <!--{{ kilometraje + ' km'}}--> <!--SE OCULTÓ POR FALTA DE USO-->
                                </div>
                            </b-col>

                            <!--OPERADORES-->
                            <b-col cols="6" lg="3" class="card-option mb-4 ml-4 mr-4 " @click="seleccionaOperador"
                                style="cursor: pointer;">

                                <div v-if="banderaOperador != 1">
                                    <b-icon icon="person" font-scale="6" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Operador</h5>
                                </div>

                                <div v-if="banderaOperador == 1">
                                    <b-icon icon="person" font-scale="2" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Operador</h5>
                                    {{ selectedOperadores }}
                                </div>
                            </b-col>

                            <!--PROVEEDORES-->

                            <b-col cols="6" lg="3" class="card-option mb-4 ml-4 mr-4 mt-4" @click="seleccionaProveedor"
                                style="cursor: pointer;">

                                <div v-if="banderaProveedor != 1">
                                    <b-icon icon="geo-alt" font-scale="6" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Proveedor</h5>
                                </div>

                                <div v-if="banderaProveedor == 1">
                                    <b-icon icon="geo-alt" font-scale="2" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Proveedor</h5>
                                    {{ selectedProveedores.proveedor }}
                                </div>
                            </b-col>

                            <!--NOTAS-->

                            <b-col cols="6" lg="3" class="card-option mb-4 ml-4 mr-4 mt-4" @click="seleccionaNotas"
                                style="cursor: pointer;">
                                <div v-if="banderaNota == 0">
                                    <b-icon icon="exclamation-circle" font-scale="6" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Notas</h5>
                                </div>

                                <div v-if="banderaNota != 0">
                                    <b-icon icon="exclamation-circle" font-scale="2" class="mb-1 mt-4"></b-icon>
                                    <h5 class="mb-5">Notas</h5>
                                    <div v-if="notaBomba != ''">
                                        <b-row align-h="center" align="center">
                                            <b-col md="1" lg="1">
                                                <b-icon icon="check-circle-fill" font-scale="1"></b-icon>
                                            </b-col>
                                            <b-col md="6" lg="6">
                                                <p>Se ingresó Nota Bomba</p>
                                            </b-col>
                                        </b-row>
                                    </div>

                                    <div v-if="notaInterna != ''">
                                        <b-row align-h="center" align="center">
                                            <b-col md="1" lg="1">
                                                <b-icon icon="check-circle-fill" font-scale="1"></b-icon>
                                            </b-col>
                                            <b-col md="6" lg="6">
                                                <p>Se ingresó Nota Interna</p>
                                            </b-col>
                                        </b-row>
                                    </div>

                                    <div v-if="notaMotivo != ''">
                                        <b-row align-h="center" align="center">
                                            <b-col md="1" lg="1">
                                                <b-icon icon="check-circle-fill" font-scale="1"></b-icon>
                                            </b-col>
                                            <b-col md="6" lg="6">
                                                <p>Se ingresó Motivo</p>
                                            </b-col>
                                        </b-row>
                                    </div>

                                    <div v-if="notaClasificacion != ''">
                                        <b-row align-h="center" align="center">
                                            <b-col md="1" lg="1">
                                                <b-icon icon="check-circle-fill" font-scale="1"></b-icon>
                                            </b-col>
                                            <b-col md="6" lg="6">
                                                <p>Se ingresó Clasificacion</p>
                                            </b-col>
                                            <b-col md="1" lg="1">
                                                {{ notaClasificacion }}
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <!--MODAL DEPARTAMENTOS-->
                        <b-row>
                            <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                                title="Seleccione el departamento" v-model="modalShow1" size="lg">
                                <b-row>
                                    <b-col>
                                        <b-form-input id="filter-input" v-model="filter" type="search"
                                            placeholder="Filtrar dependencias"></b-form-input>
                                        <b-table :items="departamentos" :fields="fieldsDepartamentos"
                                            :select-mode="selectModeDepartamentos" responsive="sm" ref="selectableTable"
                                            selectable @row-selected="onRowSelectedDepartamentos" :filter="filter"
                                            :filter-included-fields="filterOn">

                                            <template #cell(selected)="{ rowSelected }">
                                                <template v-if="rowSelected">
                                                    <span aria-hidden="true">&check;</span>
                                                    <span class="sr-only">Selected</span>
                                                </template>
                                                <template v-else>
                                                    <span aria-hidden="true">&nbsp;</span>
                                                    <span class="sr-only">Not selected</span>
                                                </template>
                                            </template>
                                        </b-table>
                                        <!--<p>
                                            {{ selectedDepartamentos }}
                                        </p>-->
                                    </b-col>
                                </b-row>
                            </b-modal>

                            <!--MODAL UNIDADES-->
                        </b-row>
                        <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                            title="Seleccione la unidad" v-model="modalShow2" size="lg">
                            <b-tabs>
                                <!--TAB 1 UNIDADES-->
                                <b-tab title="Departamento Seleccionado" active>
                                    <p></p>
                                    <b-row>
                                        <b-col>
                                            <b-form-input id="filter-input" v-model="filter" type="search"
                                                placeholder="Filtrar unidades"></b-form-input>
                                            <b-table :items="unidadesActual" :fields="fieldsUnidades"
                                                :select-mode="selectModeUnidades" responsive="sm" ref="selectableTable"
                                                selectable @row-selected="onRowSelectedUnidades" :filter="filter"
                                                :filter-included-fields="filterOn">
                                                <template #cell(selected)="{ rowSelected }">
                                                    <template v-if="rowSelected">
                                                        <span aria-hidden="true">&check;</span>
                                                        <span class="sr-only">Selected</span>
                                                    </template>
                                                    <template v-else>
                                                        <span aria-hidden="true">&nbsp;</span>
                                                        <span class="sr-only">Not selected</span>
                                                    </template>
                                                </template>
                                            </b-table>
                                            <!--<p>
                                                {{ selectedUnidades }}
                                            </p>-->
                                        </b-col>
                                    </b-row>
                                </b-tab>

                                <!--TAB 2 UNIDADES-->
                                <b-tab title="Otros Departamentos">
                                    <p></p>
                                    <b-row>
                                        <b-col>
                                            <b-form-input id="filter-input" v-model="filter" type="search"
                                                placeholder="Filtrar unidades"></b-form-input>
                                            <b-table :items="unidadesOtro" :fields="fieldsUnidades"
                                                :select-mode="selectModeUnidades" responsive="sm" ref="selectableTable"
                                                selectable @row-selected="onRowSelectedUnidades" :filter="filter"
                                                :filter-included-fields="filterOn">
                                                <template #cell(selected)="{ rowSelected }">
                                                    <template v-if="rowSelected">
                                                        <span aria-hidden="true">&check;</span>
                                                        <span class="sr-only">Selected</span>
                                                    </template>
                                                    <template v-else>
                                                        <span aria-hidden="true">&nbsp;</span>
                                                        <span class="sr-only">Not selected</span>
                                                    </template>
                                                </template>
                                            </b-table>
                                            <!--<p>
                                                {{ selectedUnidades }}
                                            </p>-->
                                        </b-col>
                                    </b-row>
                                </b-tab>
                            </b-tabs>
                        </b-modal>

                        <!--MODAL DATOS CARGA-->
                        <b-row>
                            <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                                title="Seleccione el proveedor" v-model="modalShow6" size="lg">
                                <b-row align-h="center" align="center">
                                    <b-col>
                                        <b-form-radio-group v-model="selectedCarga" :options="cargaOpciones"
                                            class="mb-3" value-field="item" text-field="name"
                                            disabled-field="notEnabled"></b-form-radio-group>
                                        <b-form-input v-model="nLitros" type="number"
                                            placeholder="Indica el número de litros"
                                            @input="onRowSelectedCarga"></b-form-input>
                                        <!--<b-form-input v-model="kilometraje" type="integer" placeholder="Indica el kilometraje acumulado"></b-form-input> -->
                                        <!--SE OCULTO POR FALTA DE USO-->
                                        <!--<p>
                                            {{ selectedCarga }}
                                            {{ nLitros }}
                                            {{ kilometraje }}
                                        </p> -->
                                    </b-col>
                                </b-row>
                            </b-modal>
                        </b-row>


                        <!--MODAL OPERADORES-->

                        <b-row>
                            <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                                title="Ingresa el nombre del operador" v-model="modalShow3" size="lg">
                                <b-form-input v-model="selectedOperadores" placeholder="Ingresa el nombre del operador"
                                    @change="onRowSelectedOperadores"></b-form-input>
                            </b-modal>
                        </b-row>

                        <!--MODAL PROVEEDORES-->
                        <b-row>
                            <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                                title="Seleccione el proveedor" v-model="modalShow4" size="lg">
                                <b-row>
                                    <b-col>
                                        <b-table :items="proveedores" :fields="fieldsProveedores"
                                            :select-mode="selectModeProveedores" responsive="sm" ref="selectableTable"
                                            selectable @row-selected="onRowSelectedProveedores">
                                            <template #cell(selected)="{ rowSelected }">
                                                <template v-if="rowSelected">
                                                    <span aria-hidden="true">&check;</span>
                                                    <span class="sr-only">Selected</span>
                                                </template>
                                                <template v-else>
                                                    <span aria-hidden="true">&nbsp;</span>
                                                    <span class="sr-only">Not selected</span>
                                                </template>
                                            </template>
                                        </b-table>
                                        <!--<p>
                                            {{ selectedProveedores }}
                                        </p>-->
                                    </b-col>
                                </b-row>
                            </b-modal>
                        </b-row>

                        <!--MODAL NOTAS-->
                        <b-row>
                            <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                                title="Ingrese sus notas" v-model="modalShow5" size="lg">
                                <b-row>
                                    <b-col>
                                        <b-form-textarea id="textarea" v-model="notaBomba"
                                            placeholder="Ingrese su nota de bomba" rows="3"
                                            max-rows="6"></b-form-textarea>
                                        <b-form-textarea id="textarea" v-model="notaInterna"
                                            placeholder="Ingrese su nota interna" rows="3"
                                            max-rows="6"></b-form-textarea>
                                        <b-form-textarea id="textarea" v-model="notaMotivo"
                                            placeholder="Ingrese su motivo" rows="3" max-rows="6"></b-form-textarea>
                                        <b-form-textarea id="textarea" v-model="notaClasificacion"
                                            placeholder="Ingrese su clasificacion" rows="3"
                                            max-rows="6"></b-form-textarea>
                                    </b-col>
                                </b-row>
                            </b-modal>
                        </b-row>



                        <b-row align-h="center" align="center">
                            <b-col cols="6" lg="3">
                                <p></p>
                                <b-button pill variant="success" size="lg" @click="generarVale"
                                    style="cursor: pointer;">Generar Vale
                                </b-button>
                            </b-col>
                        </b-row>

                        <p></p>

                        <!--MODAL VIGENCIA-->

                        <b-row>
                            <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                                title="Ingrese la vigencia de su vale" v-model="modalShow7">
                                <b-row align-h="center" align="center">
                                    <b-col>
                                        <b-form-radio-group v-model="selectedVigencia" :options="vigenciaOpciones"
                                            class="mb-3" value-field="item" text-field="name"
                                            disabled-field="notEnabled"></b-form-radio-group>
                                        <b-form-input v-model="fechaVigencia" type="number" number
                                            v-if="selectedVigencia == 0"
                                            placeholder="Ingresa el número de días"></b-form-input>
                                        <p></p>

                                        <div v-if="banderaSpinner == 0">
                                            <b-button pill @click="onRowSelectedVigencia">Confirmar</b-button>
                                        </div>

                                        <p></p>

                                        <div v-if="banderaSpinner == 1">
                                            <b-spinner label="Loading..."></b-spinner>
                                        </div>
                                        <p>
                                            <!--{{ selectedVigencia }}-->
                                        </p>
                                    </b-col>
                                </b-row>
                            </b-modal>
                        </b-row>

                        <!--MODAL VISTA VALE-->
                        <b-row>
                            <b-modal hide-footer header-bg-variant="dark" header-text-variant="light"
                                title="Descargue su vale" v-model="modalShow8">
                                <b-row>
                                    <b-col>
                                        <embed :src="valeBase64" frameborder="0" width="100%" height="800px">
                                    </b-col>
                                </b-row>
                            </b-modal>
                        </b-row>
                        <!--{{ valeBase64 }}--><!--PRINT DEL BASE64 DEL VALE AL FINAL DE LA PANTALLA-->
                    </b-col>
                </b-row>




            </b-col>
        </b-row>
    </div>
</template>




<script>
import axios from 'axios'




export default {


    computed: {
        token: {
            get: function () {
                return this.$store.state.user.token;
            },
            set: function (newIsWorking) {
                this.$store.commit("updateToken", newIsWorking);
            }
        }

    },

    data() {
        return {
            //variables Generacion Vale
            cliente: "",
            //url: "http://192.168.0.100:8080/",
            //url: "https://optimal-central-pug.ngrok-free.app/",
            //url: "https://tphavawsqa.a.pinggy.link/",
            //url: "http://192.168.0.101:8080/",
            url: "https://recaudacion.gobrecservices.com/",

            vale: '',
            modalShow1: false,
            modalShow2: false,
            modalShow3: false,
            modalShow4: false,
            modalShow5: false,
            modalShow6: false,
            modalShow7: false,
            modalShow8: false,

            banderaDepartamento: 0,
            banderaUnidad: 0,
            banderaCarga: 0,
            banderaOperador: 0,
            banderaProveedor: 0,
            banderaNota: 0,
            banderaVigencia: 0,

            banderaSpinner: 0,

            fechaVigencia: 0,

            notaInterna: '',
            notaBomba: '',
            notaMotivo: '',
            notaClasificacion: '',

            consumible: '',
            nLitros: 0,
            kilometraje: 0,

            filter: null,
            filterOn: [],

            archivoTablaValesBase64: null,

            unidadesActual: [],
            unidadesOtro: [],

            operadoresActual: [],
            operadoresOtro: [],

            valeBase64: '',

            ///variables Reportes

            reportePlaca: '',

            fieldsDepartamentos: ['descDepartamento', 'programa'],
            departamentos: [],
            selectModeDepartamentos: 'single',
            selectedDepartamentos: [],

            selectedVales: [],

            fieldsUnidades: ['descDepartamento', 'descUnidad', 'placa', 'noEconomico'],
            unidades: [],
            selectModeUnidades: 'single',
            selectedUnidades: [],

            fieldsOperadores: ['descDepartamento', 'nombre'],
            operadores: [],
            selectModeOperadores: 'single',
            selectedOperadores: '',

            cargaOpciones: [
                { item: 'Combustibles', name: 'Combustibles' },
                //{ item: 'Aceites/Aditivos', name: 'Aceites/Aditivos' } Se ocultó por falta de uso
            ],

            selectedCarga: 'Combustibles',

            vigenciaOpciones: [
                { item: 1, name: '1 Día' },
                { item: 2, name: '2 Días' },
                { item: 3, name: '3 Días' },
                { item: 4, name: '4 Días' },
                { item: 0, name: 'Otro' }
            ],

            selectedVigencia: 1,

            fieldsProveedores: ['proveedor'],
            proveedores: [],
            selectModeProveedores: 'single',
            selectedProveedores: [],

        }
    },


    created: function () {

        const queryString = window.location.href;

        const url = new URL(queryString);

        const cliente = url.pathname.split('/')[1];

        this.cliente = cliente

        axios({
            method: 'post',
            url: this.url + 'catalogosum',
            params: { "codeClient": this.cliente },
            data: null,
            headers: {
                'Authorization': this.token,

            }
        })
            .then((res) => {
                this.departamentos = res.data.departamentos
                this.unidades = res.data.unidades
                this.operadores = res.data.operadores
                this.proveedores = res.data.proveedores

                this.unidadesTabla = res.data.unidades

            }).catch(err => {

                if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

                    alert('Servicio no disponible, intente de nuevo más tarde');

                }

                else if (err.response.status == 500) {

                    alert('Error en la red, verifique su conexión a internet 1');
                }

                else {

                    alert(err);

                }
            });

    },


    methods: {

        onRowSelectedVigencia() {
            this.banderaVigencia = 1;
            this.banderaSpinner = 1;

            if (this.selectedVigencia > 0) {
                this.fechaVigencia = this.selectedVigencia
            }


            if (this.selectedVigencia == 0) {
                this.fechaVigencia = this.fechaVigencia
            }



            if (this.banderaVigencia == 1) {



                this.vale = {
                    departamento: this.selectedDepartamentos,
                    unidad: this.selectedUnidades,
                    operador: this.selectedOperadores,
                    proveedor: this.selectedProveedores,
                    notaInterna: this.notaInterna,
                    notaBomba: this.notaBomba,
                    notaMotivo: this.notaMotivo,
                    notaClasificacion: this.notaClasificacion,
                    diasVigencia: this.fechaVigencia,
                    tipoCombustibleVale: this.selectedCarga,
                    nLitrosVale: this.nLitros,
                    kilometraje: this.kilometraje
                }

                axios({
                    method: 'post',
                    url: this.url + 'generavale',

                    data: this.vale,
                    headers: {
                        'Authorization': this.token,

                    }
                })
                    .then((res) => {

                        this.valeBase64 = 'data:application/pdf;base64,' + res.data.pdf

                        this.modalShow8 = true;
                        this.banderaSpinner = 0;

                        //alert(this.valeBase64)

                    }).catch(err => {

                        if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

                            alert('Servicio no disponible, intente de nuevo más tarde');

                            this.banderaSpinner = 0;

                        }

                        else if (err.response.status == 500) {

                            alert('Error en la red, verifique su conexión a internet');

                            this.banderaSpinner = 0;
                        }


                        else {
                            if (err.config.headers.Authorization != null) {

                                const queryString = window.location.href;
                                const url = new URL(queryString);
                                const cliente = url.pathname.split('/')[1];
                                window.location.href = '/' + cliente + '/login';
                            }




                            //alert(err);

                            //alert('Servicio no disponible, intente de nuevo más tarde');

                        }

                    });

                //alert(' SE EJECUTA METODO AXIOS GENERA VALE');
            }

        },

        onRowSelectedDepartamentos(itemsSelected) {


            this.selectedDepartamentos = itemsSelected[0]
            this.banderaDepartamento = 1

            //Recorrer array de unidades y encontrar el
            //elemto que contiene las unidades del departamento seleccionado

            //Recorrer array de unidades y encontrar y crear un array
            //que contenga todas las unidades que no pertenecen al departamento selecionado

            let departamento_seleccionado = this.selectedDepartamentos.descDepartamento
            //alert(departamento_seleccionado);

            this.unidadesActual = [],
                this.unidadesOtro = [],

                this.operadoresActual = [],
                this.operadoresOtro = []

            //alert('3.5'+ this.unidades.length)

            for (let i = 0; i < this.unidades.length; i++) {

                //alert('4'+ this.unidades.length)
                //alert('4.5' + departamento_seleccionado)
                //alert('5'+ this.unidades[i].descDepartamento)

                if (this.unidades[i].descDepartamento.includes(departamento_seleccionado)) {


                    this.unidadesActual.push(this.unidades[i])

                    //alert('6'+ this.unidadesActual)
                }
                else {
                    this.unidadesOtro.push(this.unidades[i])
                }
            }

            for (let i = 0; i < this.operadores.length; i++) {
                if (this.operadores[i].descDepartamento.includes(departamento_seleccionado)) {
                    this.operadoresActual.push(this.operadores[i])
                }
                else {
                    this.operadoresOtro.push(this.operadores[i])
                }

            }

        },

        seleccionaDepartamento() {
            this.modalShow1 = true;
        },


        onRowSelectedUnidades(itemSelected) {
            this.selectedUnidades = itemSelected[0]
            this.banderaUnidad = 1
        },

        seleccionaUnidad() {
            this.modalShow2 = true;
        },


        onRowSelectedCarga() {
            this.banderaCarga = 1
        },

        seleccionaCarga() {
            this.modalShow6 = true;
        },

        onRowSelectedOperadores(itemSelected) {
            this.selectedOperadores = itemSelected
            this.banderaOperador = 1
        },

        seleccionaOperador() {
            this.modalShow3 = true;
        },

        onRowSelectedProveedores(itemSelected) {
            this.selectedProveedores = itemSelected[0]
            this.banderaProveedor = 1
        },

        seleccionaProveedor() {
            this.modalShow4 = true;
        },

        seleccionaNotas() {
            this.modalShow5 = true;
            this.banderaNota = 1;
            this.notaClasificacion = 'A1';
        },

        generarVale() {
            this.modalShow7 = true;
        },



        /*
            
    descargaTablaVales() {
    
        var byteString = atob(this.archivoValesBase64);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
    
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
    
        FileSaver.saveAs(new Blob([ab],{type:"application/octet-stream"}), 'ejemplo.xlsx');
    
    
        },
        */

    }
}

</script>



<style>
/* BASIC */

html {
    background-color: #ffffff;
}

body {
    font-family: "Poppins", sans-serif;
    height: 100vh;
}

a {
    color: #92badd;
    display: inline-block;
    text-decoration: none;
    font-weight: 400;
}

h2 {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    display: inline-block;
    margin: 40px 8px 10px 8px;
    color: #cccccc;
}



/* STRUCTURE */

.wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: 20px;
}

#formContent {
    -webkit-border-radius: 10px 10px 10px 10px;
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    padding: 30px;
    width: 90%;
    max-width: 450px;
    position: relative;
    padding: 0px;
    -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    text-align: center;
}

#formFooter {
    background-color: #f6f6f6;
    border-top: 1px solid #dce8f1;
    padding: 25px;
    text-align: center;
    -webkit-border-radius: 0 0 10px 10px;
    border-radius: 0 0 10px 10px;
}



/* TABS */

h2.inactive {
    color: #cccccc;
}

h2.active {
    color: #0d0d0d;
    border-bottom: 2px solid #ffffff;
}



/* FORM TYPOGRAPHY*/

input[type=button],
input[type=submit],
input[type=reset] {
    background-color: #56baed;
    border: none;
    color: white;
    padding: 15px 80px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    font-size: 13px;
    -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
    box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
    margin: 5px 20px 40px 20px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
    background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
    -moz-transform: scale(0.95);
    -webkit-transform: scale(0.95);
    -o-transform: scale(0.95);
    -ms-transform: scale(0.95);
    transform: scale(0.95);
}

input[type=text] {
    background-color: #f6f6f6;
    border: none;
    color: #0d0d0d;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
    width: 85%;
    border: 2px solid #f6f6f6;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
    background-color: #fff;
    border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder {
    color: #cccccc;
}



/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

@keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@-moz-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.card-option {
    box-shadow: 0px 5px 35px 5px #cccaca;
    border-radius: 15px;
    border-bottom: solid 4px rgb(68, 63, 173);
    background-color: white;
}

.fadeIn {
    opacity: 0;
    -webkit-animation: fadeIn ease-in 1;
    -moz-animation: fadeIn ease-in 1;
    animation: fadeIn ease-in 1;

    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    animation-fill-mode: forwards;

    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    animation-duration: 1s;
}

.fadeIn.first {
    -webkit-animation-delay: 0.4s;
    -moz-animation-delay: 0.4s;
    animation-delay: 0.4s;
}

.fadeIn.second {
    -webkit-animation-delay: 0.6s;
    -moz-animation-delay: 0.6s;
    animation-delay: 0.6s;
}

.fadeIn.third {
    -webkit-animation-delay: 0.8s;
    -moz-animation-delay: 0.8s;
    animation-delay: 0.8s;
}

.fadeIn.fourth {
    -webkit-animation-delay: 1s;
    -moz-animation-delay: 1s;
    animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
    display: block;
    left: 0;
    bottom: -10px;
    width: 0;
    height: 2px;
    background-color: #56baed;
    content: "";
    transition: width 0.2s;
}

.underlineHover:hover {
    color: #0d0d0d;
}

.underlineHover:hover:after {
    width: 100%;
}



/* OTHERS */

*:focus {
    outline: none;
}

#icon {
    width: 60%;
}
</style>